import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { SongViewer, type ViewerSong } from '@/components/ui/cifras/song-viewer';
import { Content } from '@/components/ui/content';
import { useRouter } from '@/hooks/use-router';
import { meta } from '@/lib/meta';
import { useSetlist } from '@/services/setlists';

export const Route = createFileRoute('/_app/setlists/$id/view')({
  head: () => meta({ label: 'Repertório' }),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { push } = useRouter();
  const { data } = useSetlist(id);

  const songs = useMemo<ViewerSong[]>(
    () =>
      (data?.items ?? []).map((item) => ({
        id: item.song.id,
        title: item.song.title,
        originalKey: item.song.originalKey,
        capo: item.song.capo,
        notes: item.song.notes,
        content: item.song.content,
        artist: item.artist?.name ?? null,
        key: item.key,
      })),
    [data],
  );

  return (
    <Content
      isLoading={!data}
      breadcrumbs={{
        icon: 'list-music',
        title: data?.name ?? 'Repertório',
        items: [
          { label: 'Repertórios', route: '/setlists' },
          { label: 'Palco', active: true },
        ],
      }}
    >
      {data && (
        <SongViewer
          key={data.id}
          songs={songs}
          setlistTitle={data.name}
          onPrint={() => push(`/setlists/${id}/print`)}
        />
      )}
    </Content>
  );
}
